import {
    init,
    getQRLoginInfo,
    getUserLoginInfo,
    scanQRLoginResult,
    cancelQrLogin,
    requestMobileCode,
    getCountryCodeList,
    login,
    chooseUser,
} from '@ks/sso';
import { inBrowser } from '@utils';

if (inBrowser) {
    init({
        env:
            process.env.net_env === 'staging'
                ? 'staging'
                : process.env.net_env === 'candidate'
                ? 'development'
                : KS_ENV === 'prod'
                ? 'production'
                : 'development',
        sid: window.__INITIAL_STATE__.loginConfig.sid || 'kuaishou.lbs.merchant',
        baseUrl:
            process.env.net_env === 'staging'
                ? 'https://ksid-staging.corp.kuaishou.com'
                : process.env.net_env === 'prod'
                ? // 'https://id.kwaixiaodian.com'
                'https://id.kuaishou.com'
                : process.env.net_env === 'prt'
                ? 'https://pre-ksid.test.gifshow.com'
                // : 'https://id.kwaixiaodian.com',
                :'https://id.kuaishou.com',
    });
}

export default {
    getQRLoginInfo,
    getUserLoginInfo,
    scanQRLoginResult,
    cancelQrLogin,
    requestMobileCode,
    getCountryCodeList,
    login,
    chooseUser,
};
